import { FilingNoDetailRes } from '../../api/Filing'
import { oaUserItem } from '../../api/Filing'
import { SearchItem } from '../../components/Search'

interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  detailInfo?: FilingNoDetailRes
  staffModalVisible: boolean
  searchdata: SearchItem
  userListdataSource: {
    data: oaUserItem[]
    loading: boolean
  }
  fillingSheetState: { state: string; approvalOpinion: string }
  dockingSalesJobNumber: string
  routeParams: { id: string }
  platformList: any[]
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setDetailInfoAction'
  | 'setStaffModalVisible'
  | 'setLoading'
  | 'setOaData'
  | 'setSearchData'
  | 'setFillingSheetState'
  | 'setDockingSalesJobNumber'
  | 'reloadStateAction'
  | 'setRouteParamsAction'
  | 'setPlatformListAction'
interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  detailInfo: undefined,
  staffModalVisible: false,
  searchdata: {},
  userListdataSource: { data: [], loading: false },
  fillingSheetState: { state: '审核中', approvalOpinion: '' },
  dockingSalesJobNumber: '',
  routeParams: { id: '' },
  platformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setStaffModalVisible':
      newstate.staffModalVisible = action.payload
      return newstate
    case 'setLoading':
      newstate.userListdataSource.loading = action.payload
      return newstate
    case 'setOaData':
      newstate.userListdataSource = action.payload.dataSource
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      return newstate
    case 'setFillingSheetState':
      newstate.fillingSheetState = action.payload
      return newstate
    case 'setDockingSalesJobNumber':
      newstate.dockingSalesJobNumber = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 选择员工弹窗
export const setStaffModalVisibleAction = (val: boolean): Action => ({
  type: 'setStaffModalVisible',
  payload: val,
})

// loading
export const changeloadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

// 设置数据
export const setdataAction = (val: {
  dataSource: { data: oaUserItem[]; loading: boolean }
}): Action => ({
  type: 'setOaData',
  payload: val,
})

// 搜索
export const setSearchData = (val: any): Action => ({
  type: 'setSearchData',
  payload: val,
})

// 报备单状态
export const setFillingSheetState = (val: {
  state: string
  approvalOpinion: string
}): Action => ({
  type: 'setFillingSheetState',
  payload: val,
})

export const setDockingSalesJobNumber = (val: string): Action => ({
  type: 'setDockingSalesJobNumber',
  payload: val,
})

export const setRouteParamsAction = (val: { id: string }): Action => ({
  type: 'setRouteParamsAction',
  payload: val,
})

export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})

export const setPlatformListAction = (val: any[]): Action => ({
  type: 'setPlatformListAction',
  payload: val,
})
import { FilingNoDetailRes } from '../../api/Filing'
import { oaUserItem } from '../../api/Filing'
import { SearchItem } from '../../components/Search'

interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  detailInfo?: FilingNoDetailRes
  staffModalVisible: boolean
  searchdata: SearchItem
  userListdataSource: {
    data: oaUserItem[]
    loading: boolean
  }
  fillingSheetState: { state: string; approvalOpinion: string }
  dockingSalesJobNumber: string
  routeParams: { id: string }
  platformList: any[]
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setDetailInfoAction'
  | 'setStaffModalVisible'
  | 'setLoading'
  | 'setOaData'
  | 'setSearchData'
  | 'setFillingSheetState'
  | 'setDockingSalesJobNumber'
  | 'reloadStateAction'
  | 'setRouteParamsAction'
  | 'setPlatformListAction'
interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  detailInfo: undefined,
  staffModalVisible: false,
  searchdata: {},
  userListdataSource: { data: [], loading: false },
  fillingSheetState: { state: '审核中', approvalOpinion: '' },
  dockingSalesJobNumber: '',
  routeParams: { id: '' },
  platformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setStaffModalVisible':
      newstate.staffModalVisible = action.payload
      return newstate
    case 'setLoading':
      newstate.userListdataSource.loading = action.payload
      return newstate
    case 'setOaData':
      newstate.userListdataSource = action.payload.dataSource
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      return newstate
    case 'setFillingSheetState':
      newstate.fillingSheetState = action.payload
      return newstate
    case 'setDockingSalesJobNumber':
      newstate.dockingSalesJobNumber = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 选择员工弹窗
export const setStaffModalVisibleAction = (val: boolean): Action => ({
  type: 'setStaffModalVisible',
  payload: val,
})

// loading
export const changeloadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

// 设置数据
export const setdataAction = (val: {
  dataSource: { data: oaUserItem[]; loading: boolean }
}): Action => ({
  type: 'setOaData',
  payload: val,
})

// 搜索
export const setSearchData = (val: any): Action => ({
  type: 'setSearchData',
  payload: val,
})

// 报备单状态
export const setFillingSheetState = (val: {
  state: string
  approvalOpinion: string
}): Action => ({
  type: 'setFillingSheetState',
  payload: val,
})

export const setDockingSalesJobNumber = (val: string): Action => ({
  type: 'setDockingSalesJobNumber',
  payload: val,
})

export const setRouteParamsAction = (val: { id: string }): Action => ({
  type: 'setRouteParamsAction',
  payload: val,
})

export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})

export const setPlatformListAction = (val: any[]): Action => ({
  type: 'setPlatformListAction',
  payload: val,
})
